import { reduce } from 'lodash';

import { SEGMENT_TYPE } from './segmentTypes';

export const africaCountryCodes = ['BW', 'NA', 'ZM', 'ZW', 'ZA', 'RW', 'MZ', 'KE', 'MU', 'TZ', 'UG', 'LS', 'SC', 'SZ', 'MW', 'CG', 'MG'];

export const isRestOfWorld = countryCode => !africaCountryCodes.includes(countryCode);

export const isOnlyRestOfWorld = itinerary => {
  const accommodations = reduce(
    itinerary?.itinerary?.segments,
    (acc, segment) => {
      if (segment.type === 'stay' /*SEGMENT_TYPE.STAY*/) {
        const restOfWorld = segment.countryCode && isRestOfWorld(segment.countryCode);
        if (!restOfWorld) {
          acc.isOnlyROW = false;
        }
      }
      return acc;
    },
    { isOnlyROW: true },
  );
  return accommodations.isOnlyROW;
};

// Stays are the only segments that place a booking: a connecting flight through Doha does not make
// an Okavango safari Rest of World. A stay with no country code is skipped rather than counted as
// either side, so an itinerary carrying none yields undefined and the caller omits the field.
export const regionTagFor = itinerary => {
  const stays = (itinerary?.itinerary?.segments || []).filter(segment => segment.type === SEGMENT_TYPE.STAY && segment.countryCode);
  const hasRestOfWorld = stays.some(stay => isRestOfWorld(stay.countryCode));
  const hasAfrica = stays.some(stay => !isRestOfWorld(stay.countryCode));

  if (hasAfrica && hasRestOfWorld) {
    return 'Africa & Rest of World';
  }
  if (hasAfrica) {
    return 'Africa';
  }
  if (hasRestOfWorld) {
    return 'Rest of World';
  }
  return undefined;
};
